/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { SubscriptionTypeDetailsService } from '../../services/subscription-type-details.service';
import { ErrorSeverityEnum } from '@irian-ro/shared-components-module';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionTypeDtoModel } from '@well/domain';

@Component({
  selector: 'well-subscription-type-tab',
  templateUrl: './subscription-type-tab.component.html',
  styleUrls: ['./subscription-type-tab.component.scss'],
})
export class SubscriptionTypeTabComponent {
  isEditMode = input<boolean>(false);

  get uuid(): string | undefined {
    return this._uuid;
  }

  @Input() set uuid(value: string) {
    this._uuid = value;
    if (value) {
      this.subscriptionTypeDetailsService.getOne(value).subscribe((res) => {
        const subscriptionType = res.data;
        if (subscriptionType) {
          this.form.patchValue({ subscriptionType: subscriptionType });
        }
      });
    }
  }

  private _uuid: string | undefined = undefined;
  form = new FormGroup({
    subscriptionType: new FormControl<SubscriptionTypeDtoModel | null>(null),
  });

  @Output() next: EventEmitter<{ next: boolean; uuid: string }> = new EventEmitter<{ next: boolean; uuid: string }>();

  msg: any[] | undefined = undefined;

  constructor(
    private subscriptionTypeDetailsService: SubscriptionTypeDetailsService,
    private translateService: TranslateService
  ) {}

  onSave() {
    this.form.markAllAsTouched();
    this.form.markAsDirty();
    if (this.form.valid) {
      this.subscriptionTypeDetailsService.save((<AbstractControl>this.form).getRawValue().subscriptionType).subscribe(
        (res: any) => {
          this.next.next({ next: true, uuid: res.uuid });
        },
        (error: any) => {
          if (error) {
            this.displayError(error);
          }
        }
      );
    }
  }

  displayError(res: any) {
    this.msg = [];
    if (res.error && res.error.fieldErrors && res.error.fieldErrors.length) {
      res.error.fieldErrors.map((value: any) => {
        this.pushMessagesToErrorComponents(ErrorSeverityEnum.error, value.message);
      });
    } else {
      this.pushMessagesToErrorComponents(ErrorSeverityEnum.error, `defaultValidationMessage`);
    }
  }

  pushMessagesToErrorComponents(severity: any, messageKey: string | string[]) {
    this.translateService.stream(`company.error.${messageKey}`).subscribe((res: string) => {
      this.msg?.push({
        severity: severity,
        summary: res,
      });
    });
  }
}
